export default __webpack_public_path__ + "static/bottle-reflection-0d6ff878751e90dce24b69cd1168ca35.png";